import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotebook: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="notebook, cover"><path d="M4.25 3.25H8.75H19.75V20.75H8.75H4.25V3.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 3.25V20.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 7.75H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 11.75H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconNotebook;
